module.exports = "/assets/data/e0a1b7b2e22179f62f0ee7fc02a8128a-SS13.data.json";